/**
 * Component names used by the module catalog (API_ENDPOINTS.WORKSHOP_CATALOG) →
 * the components that render them in /admin/workshop (#683).
 *
 * - ADMIN_SECTIONS: a module's `admin.section` (its facilitator panel)
 * - MANUAL_INPUT_EDITORS: a manual input's `adminComponent` (fills a handoff by hand)
 *
 * Only names live here; which module or handoff uses them comes from the catalog.
 */
import FutureSelectionContent from './phases/FutureSelectionContent';
import TopicFocusContent from './phases/TopicFocusContent';
import PivotPointContent from './phases/PivotPointContent';
import PivotPointsV2Content from './phases/PivotPointsV2Content';
import ReportStepContent from './phases/ReportStepContent';
import ForesightStepAdmin from './phases/ForesightStepAdmin';
import PreworkCurationAdmin from './prework/PreworkCurationAdmin';
import PremadeContextAdmin from './PremadeContextAdmin';
import StaticPivotAdmin from './StaticPivotAdmin';
import ManualPivotAdmin from './ManualPivotAdmin';
import ScenarioCatalogAdmin from './phases/ScenarioCatalogAdmin';
import PathwayTreeImportAdmin from './phases/PathwayTreeImportAdmin';
import LensItemsAdmin from './manualInputs/LensItemsAdmin';
import HmwQuestionsAdmin from './manualInputs/HmwQuestionsAdmin';
import FutureScenariosAdmin from './manualInputs/FutureScenariosAdmin';
import JuurisyytAdmin from '../../screens/systemic-v2/JuurisyytAdmin';
import JuurisyytV2Admin from '../../modules/juurisyyt_v2/admin/JuurisyytV2Admin';
import FutureReimaginedAdmin from '../../screens/future-reimagined/FutureReimaginedAdmin';
import VipupisteFocusAdmin from '../../modules/vipupiste_focus_v1/VipupisteFocusAdmin';
import SystemicMapV3Admin from '../../modules/systemic_map_v3/admin/SystemicMapV3Admin';
import FutureV2Admin from '../../modules/future_reimagined_v2/FutureV2Admin';
import StatisticsViewAdmin from '../../modules/statistics_view_v1/StatisticsViewAdmin';

export const ADMIN_SECTIONS = {
  FutureSelectionContent,
  TopicFocusContent,
  PivotPointContent,
  PivotPointsV2Content,
  ReportStepContent,
  ForesightStepAdmin,
  PreworkCurationAdmin,
  JuurisyytAdmin,
  JuurisyytV2Admin,
  FutureReimaginedAdmin,
  VipupisteFocusAdmin,
  SystemicMapV3Admin,
  FutureV2Admin,
  StatisticsViewAdmin,
};

export const MANUAL_INPUT_EDITORS = {
  PathwayTreeImportAdmin,
  ScenarioCatalogAdmin,
  PremadeContextAdmin,
  StaticPivotAdmin,
  ManualPivotAdmin,
  LensItemsAdmin,
  HmwQuestionsAdmin,
  FutureScenariosAdmin,
};

/** @returns {React.ComponentType|null} */
export function resolveAdminSection(name) {
  return (name && ADMIN_SECTIONS[name]) || null;
}

/** @returns {React.ComponentType|null} */
export function resolveManualInputEditor(name) {
  return (name && MANUAL_INPUT_EDITORS[name]) || null;
}
